import { getOrgTree } from '@/api/httpList';
const date = new Date();
const currentYear = date.getFullYear();
const yearArr = [];
for (let i = currentYear - 120; i <= currentYear; i++) {
  yearArr.unshift({
    'label': i,
    'value': i
  });
}
const monthArr = [];
for (let i = 1; i <= 12; i++) {
  monthArr.unshift({
    'label': i + '月',
    'value': i
  });
}
export default vm => {
  return [
    {
      labelWidth: 80,
      data: [
        {
          name: '机构名称',
          key: 'organizationName',
          value: '',
          type: 1,
          clearable: true
        },

        {
          name: '结算日期',
          key: 'commissionPeriod',
          value: ['1', ''],
          type: 9,
          dateType: 'year',
          clearable: true,
          change(item) {
            if (item.value[0] === '1') {
              //按年
              item.dateType = 'year';
            } else {
              //按月
              item.dateType = 'month';
            }
          },
          arr: [
            {
              label: '按年',
              value: '1'
            },
            {
              label: '按月',
              value: '2'
            }
          ]
        },
        {
          name: '结算类型',
          key: 'settlementType',
          value: '',
          type: 2,
          clearable: true,
          arr: [
            {
              label: '首期',
              value: '1'
            },
            {
              label: '续期',
              value: '2'
            },
            {
              label: '后置服务费',
              value: '3'
            },
            {
              label: '梯度活动',
              value: '4'
            },
            {
              label: '继续率追偿',
              value: '5'
            }
          ]
        }
      ]
    }
  ];
};
